// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3SzgA","item":"PaymentsMobile_item__3hrZc","label":"PaymentsMobile_label___aQGM","amount":"PaymentsMobile_amount__33V5h"};